import { createContext } from 'react';
import { ILicense } from '../models/ILicense';

export interface ILicensesContext {
  licenses: ILicense[] | null;
  onRefresh: () => Promise<any>;
}

export const LicensesContext = createContext<ILicensesContext>({
  licenses: [],
  onRefresh: () => Promise.resolve(null),
});
